import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/layout/Navbar";
import PlatformPageHero from "../components/platform/PlatformPageHero";
import CookieNotice from "../components/sections/legal/CookieNotice";

const CookiePolicyPage = () => (
  <div className="min-h-screen bg-paper">
    <Navbar />
    <main className="pt-16">
      <PlatformPageHero
        eyebrow="Cookies"
        title="What this website stores in your browser"
        body="This page is about telcofy.ai, the website you are reading now, and the small amount it keeps on your device."
      />
      <CookieNotice />

      <section className="pb-24 bg-paper">
        <div className="max-w-3xl mx-auto px-6">
          <p className="text-sm text-ink-muted leading-relaxed">
            How Telcofy processes mobile-network data inside the operator
            boundary is a different subject with different rules, and none of
            it involves this website.{" "}
            <Link
              to="/platform/privacy"
              className="font-medium text-brand-600 underline underline-offset-2 hover:text-brand-700"
            >
              Privacy architecture
            </Link>{" "}
            covers that.
          </p>
        </div>
      </section>
    </main>
  </div>
);

export default CookiePolicyPage;
